import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "row page-head",
  id: "page_head"
};
const _hoisted_2 = {
  class: "col-12 padding-zero"
};
const _hoisted_3 = {
  class: "head-img mb-2"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "product_explain"
};
const _hoisted_6 = {
  class: "product_guide"
};
const _hoisted_7 = {
  class: "product_guide_part_title"
};
const _hoisted_8 = {
  class: "product_guide_part_list"
};
const _hoisted_9 = {
  class: "row"
};
const _hoisted_10 = {
  id: "carouselExampleControls",
  class: "carousel slide",
  "data-bs-ride": "carousel",
  "data-interval": "4000"
};
const _hoisted_11 = {
  class: "carousel-inner"
};
const _hoisted_12 = {
  class: "carousel-item active"
};
const _hoisted_13 = {
  class: "d-flex align-items-center justify-content-center"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "carousel-item"
};
const _hoisted_18 = {
  class: "d-flex align-items-center justify-content-center"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "row upload-sample"
};
const _hoisted_23 = {
  class: "col-5 d-flex align-items-center justify-content-center"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "col-2 d-flex align-items-center justify-content-center"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "col-5 d-flex align-items-center justify-content-center"
};
const _hoisted_28 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    class: "image_fill",
    src: $props.headImgUrl,
    fit: "contain"
  }, null, 8, _hoisted_4)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString($options.get_product_introduce), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('messages.product_part_titile')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.get_product_part, (part, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("p", _hoisted_8, "* " + _toDisplayString(part), 1)]);
  }), 128))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
    src: $props.carousel_01,
    class: "img-carousel"
  }, null, 8, _hoisted_14), _createElementVNode("img", {
    src: $props.carousel_02,
    class: "img-carousel"
  }, null, 8, _hoisted_15), _createElementVNode("img", {
    src: $props.carousel_03,
    class: "img-carousel"
  }, null, 8, _hoisted_16)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: $props.carousel_04,
    class: "img-carousel"
  }, null, 8, _hoisted_19), _createElementVNode("img", {
    src: $props.carousel_05,
    class: "img-carousel"
  }, null, 8, _hoisted_20), _createElementVNode("img", {
    src: $props.carousel_06,
    class: "img-carousel"
  }, null, 8, _hoisted_21)])])]), _cache[0] || (_cache[0] = _createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleControls\" data-bs-slide=\"prev\" data-v-b8712c8c><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-b8712c8c></span><span class=\"visually-hidden\" data-v-b8712c8c>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleControls\" data-bs-slide=\"next\" data-v-b8712c8c><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-b8712c8c></span><span class=\"visually-hidden\" data-v-b8712c8c>Next</span></button>", 2))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
    src: $props.ex_original,
    class: "img-fluid"
  }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
    src: $data.arrow_icon,
    class: "img-fluid"
  }, null, 8, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    src: $props.ex_target,
    class: "img-fluid"
  }, null, 8, _hoisted_28)])])])]);
}